// extracted by mini-css-extract-plugin
module.exports = {"list":"idt-listerrors_list__2fsdg"};